var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_2895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 36.026C16.5734 36.026 16.1018 35.9376 15.6527 35.7633L4.7511 31.5315V38.6363C4.7511 39.2045 5.1075 39.7117 5.64207 39.9042L21.7801 45.7167V31.7295L20.4045 34.0976C19.7136 35.2871 18.4298 36.026 17.0542 36.026Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9465 36.0255C27.5708 36.0255 26.287 35.2865 25.5961 34.0971L24.4755 32.1679V45.73L40.652 39.9036C41.1865 39.7111 41.5429 39.2039 41.5429 38.6357V31.417L30.3479 35.7627C29.8988 35.9371 29.4273 36.0255 28.9465 36.0255Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8355 17.0307C13.0324 16.0526 12.3831 14.9442 11.9235 13.7427L8.33173 15.0362L13.8355 17.0307Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6924 15.0275L34.0905 13.7075C33.6302 14.9225 32.976 16.0429 32.1653 17.0304L37.6924 15.0275Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8321 25.3933L41.3598 17.5876C41.0533 17.0527 40.4064 16.8154 39.8268 17.0256L23.0003 23.1216L6.17391 17.0256C5.59424 16.8154 4.94738 17.0527 4.64083 17.5876L0.183118 25.3678C0.0598538 25.583 -0.0100437 25.8276 0.00109674 26.0753C0.0244558 26.5933 0.350045 27.0281 0.810219 27.2067L16.5955 33.3342C16.7457 33.3925 16.9009 33.4204 17.0542 33.4204C17.4951 33.4204 17.9188 33.1896 18.1516 32.7887L23.0002 24.1138L27.8489 32.7887C28.0817 33.1895 28.5053 33.4204 28.9463 33.4204C29.0996 33.4204 29.2548 33.3925 29.405 33.3342L45.1903 27.2067C45.5348 27.0729 45.8039 26.7956 45.9272 26.4472C46.0507 26.0988 46.0159 25.714 45.8321 25.3933Z",
    fill: "#5BA1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 18.769C28.1006 18.769 32.25 14.6196 32.25 9.51933C32.25 4.41906 28.1006 0.269775 23.0003 0.269775C17.9001 0.269775 13.7508 4.41915 13.7508 9.51942C13.7508 14.6197 17.9001 18.769 23.0003 18.769ZM19.1725 10.9355C18.6462 10.4092 18.6462 9.55599 19.1725 9.02969C19.6988 8.50339 20.5521 8.50339 21.0783 9.02969L21.8385 9.78985L24.9679 6.66045C25.4941 6.13416 26.3474 6.13416 26.8737 6.66045C27.4 7.18675 27.4 8.03999 26.8737 8.56628L22.7915 12.6485C22.5283 12.9117 22.1834 13.0433 21.8386 13.0433C21.4938 13.0433 21.1488 12.9118 20.8857 12.6486L19.1725 10.9355Z",
    fill: "#5BA1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_2895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPurchase);
export default __webpack_public_path__ + "static/media/icon-purchase.fcedd427.svg";
export { ForwardRef as ReactComponent };